module.exports = __webpack_public_path__ + "static/media/avatar-m.5d269184.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar-m.gif
// module id = 1479
// module chunks = 0